import type { PropsWithChildren } from 'react';
import type { SubjectActions, SubjectKey, SubjectPayload, SubjectType } from '../../types/acl-types.ts';
import { Enforce } from './enforce';

type BaseCanProps<TKey extends SubjectKey> = {
    field?: keyof SubjectPayload<TKey>; // TODO: Improve this type to read from SubjectFieldKey
    deny?: boolean;
} & PropsWithChildren;

type CanProps<TKey extends SubjectKey> =
    | {
          I: SubjectActions<TKey>;
          a: SubjectType<TKey>;
          an?: never;
          do?: never;
          on?: never;
      }
    | {
          I: SubjectActions<TKey>;
          a?: never;
          an: SubjectType<TKey>;
          do?: never;
          on?: never;
      }
    | {
          I?: never;
          a?: never;
          an?: never;
          do: SubjectActions<TKey>;
          on: SubjectType<TKey>;
      };

export const Can = <TKey extends SubjectKey>(props: BaseCanProps<TKey> & CanProps<TKey>) => {
    const subject = props.a || props.an || props.on;
    const action = props.I || props.do;

    return (
        <Enforce action={action!} subject={subject!} field={props.field} deny={props.deny}>
            <Enforce.Allowed>{props.children}</Enforce.Allowed>
        </Enforce>
    );
};
